import { IFormErrors } from '@interfaces/IFormsErrors';
import { IUser } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EProfileChangesActions {
  EditSelfProfileRequest = '[Profile] Edit Self Profile Request',
  EditSelfProfileSuccess = '[Profile] Edit Self Profile Success',
  EditSelfProfileFailure = '[Profile] Edit Self Profile Failure',
  ClearErrorsEditSelfProfile = '[Profile] Clear Errors Edit Self Profile',

  EditAvatarRequest = '[Profile] Edit Avatar Request',
  EditAvatarSuccess = '[Profile] Edit Avatar Success',
  EditAvatarFailure = '[Profile] Edit Avatar Failure',
}

export class ClearErrorsEditSelfProfile implements Action {
  public readonly type = EProfileChangesActions.ClearErrorsEditSelfProfile;
}

export class EditSelfProfileRequest implements Action {
  public readonly type = EProfileChangesActions.EditSelfProfileRequest;

  constructor(public id: number, public userData: IUser) {}
}

export class EditSelfProfileSuccess implements Action {
  public readonly type = EProfileChangesActions.EditSelfProfileSuccess;
}

export class EditSelfProfileFailure implements Action {
  public readonly type = EProfileChangesActions.EditSelfProfileFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class EditAvatarRequest implements Action {
  public readonly type = EProfileChangesActions.EditAvatarRequest;

  constructor(public userId: number, public data: FormData) {}
}

export class EditAvatarSuccess implements Action {
  public readonly type = EProfileChangesActions.EditAvatarSuccess;
}

export class EditAvatarFailure implements Action {
  public readonly type = EProfileChangesActions.EditAvatarFailure;

  constructor(public errors: IFormErrors) {}
}

export type ProfileChangesActions =
  | EditSelfProfileRequest
  | EditSelfProfileSuccess
  | EditSelfProfileFailure
  | EditAvatarRequest
  | EditAvatarSuccess
  | EditAvatarFailure
  | ClearErrorsEditSelfProfile;
